import {
  DataTable,
  DataType,
  ExecuteParameters,
  ExecuteResponse,
  Notification,
  SelectedMarksTable,
  UnderlyingDataTable,
  VerbId
} from '../../JsApiInternalContract';

// tslint:disable:no-any

/** This function is called when we receive newer version and parameters from the external before we send it to platform */
export type DowngradeExecuteCall =
  (verb: VerbId, parameters: ExecuteParameters) => { verb: VerbId; parameters: ExecuteParameters };

/** This function is called when we receive a response back from platform and we need to upgrade it to external's version */
export type UpgradeExecuteReturn =
  (executeResponse: ExecuteResponse) => ExecuteResponse;

/** This function is called when we receive a notification from platform and we need to upgrade it to external's version */
export type UpgradeNotification =
  (notification: Notification) => Notification;

// 1.2 -> 1.0 Translations
// Uncomment this line to import from the V1 definition of the API
// import * as V1 from '@tableau-api-internal-contract-js_v1';

/**
 * Prior to 2019.2 (internal-contract v1.9), DataValue.value were all strings.
 * Go through all DataValue objects. If we have a string, but the type should not be a string,
 * convert it to the correct type. The type of DataValue.value is 'any' in the contract, so
 * this change doesn't need any updates to classes or types.
*/
export function UpgradeDataTableTypes(executeResponse: ExecuteResponse): ExecuteResponse {
  if (!executeResponse) {
    return executeResponse;
  }

  let oldUnderlyingDataTable = executeResponse.result as UnderlyingDataTable;
  if (oldUnderlyingDataTable.data !== undefined && oldUnderlyingDataTable.isSummary !== undefined) {
    convertDataValues(oldUnderlyingDataTable.data);
    return executeResponse;
  }

  let oldSelectedMarksTable = executeResponse.result as SelectedMarksTable;
  if (oldSelectedMarksTable.data !== undefined && Array.isArray(oldSelectedMarksTable.data)) {
    oldSelectedMarksTable.data.forEach(marksTable => {
      convertDataValues(marksTable);
    });
    return executeResponse;
  }

  return executeResponse;
}

function convertDataValues(table: DataTable): void {
  // dataTable is a two-dimensional array of data. First index is the row, second is the column.
  if (table === undefined || table.dataTable === undefined || !Array.isArray(table.dataTable)) {
    return;
  }

  table.dataTable.forEach(row => {
    row.forEach((dataValue, columnIndex) => {
      let value = dataValue.value;
      if (value !== null) {
        dataValue.value = convertToType(value, table.headers[columnIndex].dataType);
      }
    });
  });
}

function convertToType(valueAsString: string, type: DataType): any {
  switch (type) {
    case DataType.Bool:
      return isSpecial(valueAsString) ? valueAsString : valueAsString.toLowerCase() === 'true';

    case DataType.Int:
    case DataType.Float:
      return isSpecial(valueAsString) ? valueAsString : Number(valueAsString);

    case DataType.Date:
    case DataType.DateTime:
    // Discrete dates are type DataType.Int, and handled above.
    // Continuous dates are just strings in this format: "YYYY-MM-DD [HH:MM:SS]"
    // fallthrough...
    case DataType.Spatial:
    case DataType.String:
    default:
      return valueAsString;
  }
}

function isSpecial(valueAsString: string): boolean {
  // Special values come to us as '%null%', '%all%', '%wildcard%', '%missing%'...
  // (See DataValueFormatter.cpp)

  if (valueAsString.length > 0 && valueAsString[0] === '%' && valueAsString[valueAsString.length - 1] === '%') {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ../../../../src/versioning/external/ExternalVersionTranslations.ts


// WEBPACK FOOTER //
// webpack:///src/versioning/external/ExternalVersionTranslations.ts